<template>
  <div class="app-container myCashCoupons">
    <h1 class="title">
      <span>我的代金券</span>
      <el-button type="text" icon="el-icon-refresh" @click="refreshCoupons">刷新券包</el-button>
    </h1>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="未使用" name="UN_CHECK" lazy>
        <coupon-list ref="uncheck" status="UN_CHECK"></coupon-list>
      </el-tab-pane>
      <el-tab-pane label="已使用" name="CHECKED" lazy>
        <coupon-list ref="checked" status="CHECKED"></coupon-list>
      </el-tab-pane>
      <el-tab-pane label="已过期" name="EXPIRED" lazy>
        <coupon-list ref="expired" status="EXPIRED"></coupon-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import {fetchFreshCashCoupons} from "../../../api/xunyou";
import CouponList from './couponList';
export default {
  name: 'myCashCoupons',
  components: {
    CouponList
  },
  data() {
    return {
      activeTab: 'UN_CHECK'
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  methods: {
    refreshCoupons () {
      fetchFreshCashCoupons({ muid: this.userId }).then(res => {
        console.log('领券结果：', res);
        if (res.code === 0) {
          if (this.$refs.uncheck) {
            this.$refs.uncheck.search();
          }
          if (this.$refs.checked) {
            this.$refs.checked.search();
          }
          if (this.$refs.expired) {
            this.$refs.expired.search();
          }
          if (res.data.length) {
            this.$message.success(`已领取${res.data.length}张代金券！`);
          }
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.log('error', err)
        this.$message.error('请求失败，请稍候重试');
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.title{
  font-size: 20px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myCashCoupons.vue